import { createElement, ReactNode } from 'react'

type Size = 'xl' | 'lg' | 'md' | 'sm'

const sizes: Record<Size, string> = {
  xl: 'text-body-xl',
  lg: 'text-body-lg',
  md: 'text-body-md',
  sm: 'text-body-sm',
}

type Tone = 'primary' | 'secondary' | 'tertiary' | 'muted' | 'inverse'

const tones: Record<Tone, string> = {
  primary: 'text-ink-primary',
  secondary: 'text-ink-secondary',
  tertiary: 'text-ink-tertiary',
  muted: 'text-ink-muted',
  inverse: 'text-ink-inverse',
}

interface TextProps {
  children: ReactNode
  as?: 'p' | 'span' | 'div'
  size?: Size
  tone?: Tone
  className?: string
}

export default function Text({
  children,
  as = 'p',
  size = 'md',
  tone = 'secondary',
  className = '',
}: TextProps) {
  return createElement(
    as,
    { className: `${sizes[size]} ${tones[tone]} ${className}` },
    children
  )
}
